(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/assets/javascripts/views/terms.js') >= 0) return;  svs.modules.push('/modules/customer-service/assets/javascripts/views/terms.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.customer_service.views.Terms = Backbone.Marionette.View.extend({
    tagName: 'div',
    id: 'terms',
    modelEvents: {
      change: 'render'
    },

    template: function(data) {
      return svs.customer_service.templates.terms(data);
    },

    initialize: function() {
      svs.customer_service_logger.debug('svs.customer_service.views.Terms - initialize');
    },

    onRender: function() {}
  });
})(Backbone, _, svs);

 })(window);